export function renderGenGetSelectOptionsContentServerActionTemplate({
  ctxSelectOptionsTableVar,
  ctxCacheReadImport,
  ctxCamelSingular,
  ctxSingular,
  selectOptionFieldNames,
  ctxCacheLifeLine,
  ctxSingularText
}: {
  ctxSelectOptionsTableVar: string
  ctxCacheReadImport: string
  ctxCamelSingular: string
  ctxSingular: string
  selectOptionFieldNames: string
  ctxCacheLifeLine: string
  ctxSingularText: string
}): string {
  return `'use server'

import db from '@admin/db'
import { ${ctxSelectOptionsTableVar} } from '@admin/db/schema'
import { asc, eq } from 'drizzle-orm'
${ctxCacheReadImport}
import { ${ctxCamelSingular}SelectOptionsCacheTags } from './types'
import type { ${ctxSingular}SelectOption, ${ctxSingular}SelectOptionFieldName } from './types'

const SELECT_OPTION_FIELDS = [${selectOptionFieldNames}] as const

function isSelectOptionFieldName(fieldName: string): fieldName is ${ctxSingular}SelectOptionFieldName {
  return (SELECT_OPTION_FIELDS as readonly string[]).includes(fieldName)
}

export async function get${ctxSingular}SelectOptions(
  fieldName: ${ctxSingular}SelectOptionFieldName
): Promise<${ctxSingular}SelectOption[]> {
  'use cache'${ctxCacheLifeLine}
  cacheTag(${ctxCamelSingular}SelectOptionsCacheTags.byField(fieldName))

  if (!isSelectOptionFieldName(fieldName)) return []

  try {
    const rows = await db
      .select()
      .from(${ctxSelectOptionsTableVar})
      .where(eq(${ctxSelectOptionsTableVar}.fieldName, fieldName))
      .orderBy(asc(${ctxSelectOptionsTableVar}.label))

    return rows as ${ctxSingular}SelectOption[]
  } catch (error) {
    console.error('Error fetching ${ctxSingularText} select options:', error)
    return []
  }
}
`
}
